import type React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";

const ContentManagementPage: React.FC = () => {
	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">コンテンツ管理</h1>

			<Tabs defaultValue="announcements">
				<TabsList>
					<TabsTrigger value="announcements">お知らせ</TabsTrigger>
					<TabsTrigger value="faq">FAQ</TabsTrigger>
					<TabsTrigger value="pages">ページ</TabsTrigger>
				</TabsList>

				<TabsContent value="announcements">
					<Card className="p-6">
						{/* お知らせ管理コンポーネント */}
						<h2 className="text-xl font-semibold mb-4">お知らせ管理</h2>
						{/* 実装予定 */}
					</Card>
				</TabsContent>

				<TabsContent value="faq">
					<Card className="p-6">
						{/* FAQ管理コンポーネント */}
						<h2 className="text-xl font-semibold mb-4">FAQ管理</h2>
						{/* 実装予定 */}
					</Card>
				</TabsContent>

				<TabsContent value="pages">
					<Card className="p-6">
						{/* ページ管理コンポーネント */}
						<h2 className="text-xl font-semibold mb-4">ページ管理</h2>
						{/* 実装予定 */}
					</Card>
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default ContentManagementPage;
